export default __webpack_public_path__ + "static/media/tesla_clone.02855f8a.webp";